import { systemStatuses } from '@juvare/contact-management/backend/features/accounts/shared';
import { z } from 'zod';
import { shiftParticipantRowSchema, } from '../shared/schemas/shiftParticipantCommonSchema';
const getParticipantsByShiftIdParamsSchema = z.object({
    shiftId: z.string().uuid().optional(),
    isVolunteerView: z.boolean().optional(),
    filterAccountSystemStatuses: z.enum(systemStatuses).array().optional(),
    filter: z.any().optional(),
    orderBy: z.any().optional(),
});
const getParticipantsByShiftIdResponseSchema = z.object({
    rows: shiftParticipantRowSchema.array(), // TODO: Change to use Zod typed columns after PLAT-2704
    total: z.number(),
});
export const getParticipantsByShiftIdFunctionDef = {
    name: 'getParticipantsByShiftId',
    requestSchema: getParticipantsByShiftIdParamsSchema,
    responseSchema: getParticipantsByShiftIdResponseSchema,
};
